// 사용 환경이 desktop인지 확인하는 함수
export const isDesktop = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
    return false;
  }
  return true;
};
